export default __webpack_public_path__ + "static/media/22-large.0e1f401f.jpg";